import storefrontDe from '@/locales/de.json' with { type: 'json' }
import storefrontEn from '@/locales/en.json' with { type: 'json' }
import storefrontEs from '@/locales/es.json' with { type: 'json' }
import storefrontFr from '@/locales/fr.json' with { type: 'json' }
import storefrontIt from '@/locales/it.json' with { type: 'json' }
import storefrontNl from '@/locales/nl.json' with { type: 'json' }
import storefrontPl from '@/locales/pl.json' with { type: 'json' }
import { FALLBACK_LOCALE, Language, supportedLocales } from '@/types'
import { Ref, watch } from 'vue'
import {
  ComposerNumberFormatting,
  ComposerTranslation,
  createI18n,
  IntlNumberFormat,
  IntlNumberFormats,
  Locale
} from 'vue-i18n'
import {
  de as vuetifyDe,
  en as vuetifyEn,
  es as vuetifyEs,
  fr as vuetifyFr,
  it as vuetifyIt,
  nl as vuetifyNl,
  pl as vuetifyPl
} from 'vuetify/locale'

const en = { $vuetify: { ...vuetifyEn }, ...storefrontEn }
const de = { $vuetify: { ...vuetifyDe }, ...storefrontDe }
const fr = { $vuetify: { ...vuetifyFr }, ...storefrontFr }
const es = { $vuetify: { ...vuetifyEs }, ...storefrontEs }
const nl = { $vuetify: { ...vuetifyNl }, ...storefrontNl }
const it = { $vuetify: { ...vuetifyIt }, ...storefrontIt }
const pl = { $vuetify: { ...vuetifyPl }, ...storefrontPl }

type MessageSchema = typeof en

const getNumberFormats = (): IntlNumberFormats<IntlNumberFormat, Language> => {
  const numberFormat: IntlNumberFormat = {
    currency: {
      style: 'currency',
      currency: 'EUR'
    },
    percentage: {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }

  const numberFormats: IntlNumberFormats = {}

  supportedLocales.forEach((locale) => {
    numberFormats[locale] = numberFormat
  })

  return numberFormats
}

const getLocale = () => {
  return isSupportedLocale(navigator.language.substring(0, 2))
    ? navigator.language.substring(0, 2)
    : FALLBACK_LOCALE
}

const isSupportedLocale = (localeToCheck: string): localeToCheck is Locale => {
  const supportedLocale = supportedLocales.find((locale) => locale === localeToCheck)
  return supportedLocale != undefined
}

const i18n = createI18n<[MessageSchema], Locale, false>({
  locale: getLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages: {
    en,
    de,
    fr,
    es,
    nl,
    it,
    pl
  },
  numberFormats: getNumberFormats(),
  legacy: false
})

// Keep the html lang attribute in sync with the displayed language
watch(
  i18n.global.locale as unknown as Ref<string>,
  (locale) => {
    document.documentElement.lang = locale
  },
  { immediate: true }
)

export default i18n
export const t: ComposerTranslation = i18n.global.t
export const n: ComposerNumberFormatting = i18n.global.n
export { isSupportedLocale }
